export enum SIZES {
  sm = "small",
  md = "medium",
}

export enum TEXT_ALIGN {
  center = "center",
  left = "left",
  right = "right",
}

export enum CELL_TYPES {
  text = "text",
  percent = "percent",
  dateTime = "dateTime",
  chip = "chip",
}

export enum INPUT_VARIANTS {
  filled = "filled",
  outlined = "outlined",
  standard = "standard",
}

export enum FILTER_KEYS {
  MARKS = "marks",
  PROGRESS_STATUS = "progressStatus",
  USER_STATUS = "userStatus",
  TRUST_SCORE = "trustScore",
  STRONG_AREAS = "strongAreas",
}
